"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParseInfo = void 0;

var Decorators_1 = require("../Decorators");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */


var ParseInfo = /*#__PURE__*/function () {
  function ParseInfo(atnSimulator) {
    _classCallCheck(this, ParseInfo);

    this.atnSimulator = atnSimulator;
  }
  /**
   * Gets an array of {@link DecisionInfo} instances containing the profiling
   * information gathered for each decision in the ATN.
   *
   * @returns An array of {@link DecisionInfo} instances, indexed by decision
   * number.
   */


  _createClass(ParseInfo, [{
    key: "getDecisionInfo",
    value: function getDecisionInfo() {
      return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */

  }, {
    key: "getLLDecisions",
    value: function getLLDecisions() {
      var decisions = this.atnSimulator.getDecisionInfo();
      var LL = [];

      for (var i = 0; i < decisions.length; i++) {
        var fallBack = decisions[i].LL_Fallback;

        if (fallBack > 0) {
          LL.push(i);
        }
      }

      return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */

  }, {
    key: "getTotalTimeInPrediction",
    value: function getTotalTimeInPrediction() {
      var decisions = this.atnSimulator.getDecisionInfo();
      var t = 0;

      var _iterator = _createForOfIteratorHelper(decisions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var decision = _step.value;
          t += decision.timeInPrediction;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */

  }, {
    key: "getTotalSLLLookaheadOps",
    value: function getTotalSLLLookaheadOps() {
      var decisions = this.atnSimulator.getDecisionInfo();
      var k = 0;

      var _iterator2 = _createForOfIteratorHelper(decisions),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var decision = _step2.value;
          k += decision.SLL_TotalLook;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */

  }, {
    key: "getTotalLLLookaheadOps",
    value: function getTotalLLLookaheadOps() {
      var decisions = this.atnSimulator.getDecisionInfo();
      var k = 0;

      var _iterator3 = _createForOfIteratorHelper(decisions),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var decision = _step3.value;
          k += decision.LL_TotalLook;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */

  }, {
    key: "getTotalSLLATNLookaheadOps",
    value: function getTotalSLLATNLookaheadOps() {
      var decisions = this.atnSimulator.getDecisionInfo();
      var k = 0;

      var _iterator4 = _createForOfIteratorHelper(decisions),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var decision = _step4.value;
          k += decision.SLL_ATNTransitions;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */

  }, {
    key: "getTotalLLATNLookaheadOps",
    value: function getTotalLLATNLookaheadOps() {
      var decisions = this.atnSimulator.getDecisionInfo();
      var k = 0;

      var _iterator5 = _createForOfIteratorHelper(decisions),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var decision = _step5.value;
          k += decision.LL_ATNTransitions;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */

  }, {
    key: "getTotalATNLookaheadOps",
    value: function getTotalATNLookaheadOps() {
      var decisions = this.atnSimulator.getDecisionInfo();
      var k = 0;

      var _iterator6 = _createForOfIteratorHelper(decisions),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var decision = _step6.value;
          k += decision.SLL_ATNTransitions;
          k += decision.LL_ATNTransitions;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return k;
    }
  }, {
    key: "getDFASize",
    value: function getDFASize(decision) {
      if (decision) {
        var decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
        return decisionToDFA.states.size;
      } else {
        var n = 0;
        var _decisionToDFA = this.atnSimulator.atn.decisionToDFA;

        for (var i = 0; i < _decisionToDFA.length; i++) {
          n += this.getDFASize(i);
        }

        return n;
      }
    }
  }]);

  return ParseInfo;
}();

__decorate([Decorators_1.NotNull], ParseInfo.prototype, "getDecisionInfo", null);

__decorate([Decorators_1.NotNull], ParseInfo.prototype, "getLLDecisions", null);

ParseInfo = __decorate([__param(0, Decorators_1.NotNull)], ParseInfo);
exports.ParseInfo = ParseInfo;